import React from "react";
import clsx from 'clsx';
import Icon, { Icons } from "../../Icon/Icon";
import styles from "../styles/Input.module.css";
import Typography from "../../Typography/Typography";

export interface InputProps {
    id?: string;
    name: string;
    label?: string;
    defaultValue?: string;
    value?: string;
    placeholder?: string;
    className?: string;
    type?: "text" | "email" | "password" | "number" | "search";

    disabled?: boolean;
    error?: boolean;
    inputMode?: "numeric";
    pattern?: "[0-9]*";
    maxWidth?: string;
    success?: boolean;
    required?: boolean;
    invertColors?: boolean;
    persistSuccessState?: boolean;
    'data-state'?: 'hover'|'focus'|'active';
    errorMessage?: string;
    readOnly?: boolean;

    icon?: Icons;

    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const Input = ({
    id,
    name,
    label,
    placeholder,
    value,
    defaultValue,
    type = "text",
    disabled,
    maxWidth,
    success,
    error,
    invertColors,
    icon,
    required,
    persistSuccessState = false,
    errorMessage,
    className,

    onChange,
    onKeyDown,
    onBlur,
    onFocus,

    ...rest
}: InputProps) => {
    const cnInput = clsx(styles.input,
        {
            [styles.inputError]: error,
            [styles.inputDisabled]: disabled,
            [styles.inputInvertColor]: invertColors,
        },
        className,
    );

    const inlineStyles = {
        maxWidth: maxWidth || '',
    }

    return (
        <label htmlFor={id || name} className={styles.inputLabel} style={inlineStyles}>
            {!!label && <span>{label}</span>}
            <div className={styles.inputWrap}>
                <input
                    id={id || name}
                    name={name}
                    type={type}
                    className={cnInput}
                    placeholder={placeholder}
                    value={value}
                    defaultValue={defaultValue}
                    required={required}
                    onChange={onChange}
                    onBlur={onBlur}
                    onKeyDown={onKeyDown}
                    onFocus={onFocus}
                    disabled={disabled}
                    {...rest}
                />
                {error && (
                    <Icon
                        icon="cross_circle_fill"
                        className={`text-status-error-default motion-safe:animate-drop-fade-in ${styles.inputIcon} pointer-events-none`}
                    />
                )}
                {success && (
                    <Icon
                        icon="check_circle"
                        className={`text-status-success-default ${(!persistSuccessState) ? 'motion-safe:animate-drop-fade-in-out' : ''} ${styles.inputIcon} pointer-events-none`}
                    />
                )}
                {!error && !success && icon
                    ? <Icon icon="search" className={`${styles.inputIcon} pointer-events-none`} />
                    : null}
            </div>
            {errorMessage
                ? <Typography variant="meta" className="block mt-0.5 font-semibold">{errorMessage}</Typography>
                : null}
        </label>
    );
};

export default Input;
